export let MembersAreaEvent = /*#__PURE__*/function (MembersAreaEvent) {
  MembersAreaEvent["MemberChanged"] = "MEMBERS_CHANGED";
  MembersAreaEvent["TabChanged"] = "TAB_CHANGED";
  return MembersAreaEvent;
}({});
//# sourceMappingURL=types.js.map